import React from 'react';

import Typography from '@material-ui/core/Typography';
import Box from '@material-ui/core/Box';

import { useStyles } from './styles';

const descriptionTextStyle = { color: '#040C14', fontSize: 14 };

export const Point = ({ order, title, description }) => {
  const classes = useStyles();
  const { text, list } = description ?? {};
  const hasList = Array.isArray(list) && list.length > 0;

  if (!title) return null;
  if (!text && !hasList) return null;

  return (
    <div className={classes.container}>
      <Typography style={{ color: '#77CC21', fontSize: 80, fontWeight: 'bold' }}>{order}</Typography>
      <Box mt={5} mb={5}>
        <Typography className={classes.title}>{title}</Typography>
      </Box>
      {text && (
        <Typography
          style={{
            ...descriptionTextStyle,
            marginBottom: hasList ? '16px' : 0,
          }}
        >
          {text}
        </Typography>
      )}
      {hasList && (
        <Box component="ul" className={classes.descriptionList}>
          {list.map(item => (
            <Box component="li" key={item}>
              <Typography style={descriptionTextStyle}>{item}</Typography>
            </Box>
          ))}
        </Box>
      )}
    </div>
  );
};
